export default __webpack_public_path__ + "static/media/cheatday_1@3x.38e2c4cd.jpg";